<ngrx-busy>
  <mat-dialog-content>
    <div class="info-card">
      @for (info of sim$ | async | keyvalue; track info) {
        <p><span>{{info.key}}</span> {{info.value}}</p>
      }
    </div>
  </mat-dialog-content>
</ngrx-busy>
